import { getParamsByKey } from '@weareconceptstudio/core';

type CreateQueryStringParams = {
	searchParams: URLSearchParams | string;
	typeId: string | number | string[] | number[] | null | undefined;
	type: string;
	multiple?: boolean;
};

export default function createQueryString({ searchParams, typeId, type, multiple = false }: CreateQueryStringParams): string {
	const params = new URLSearchParams(searchParams);

	if (multiple) {
		//! Handle array input (for clearing all or setting multiple values at once)
		if (Array.isArray(typeId)) {
			if (typeId.length === 0) {
				//! Clear all values
				params.delete(type);
			} else {
				//! Set specific array of values
				const newVal = typeId.map(String).join(',');
				params.set(type, newVal);
			}
		} else {
			//! Handle single value toggle
			let paramsArr = getParamsByKey(params, type);
			const newVal = typeId?.toString();

			if (paramsArr && newVal) {
				paramsArr = paramsArr.indexOf(newVal) > -1 ? paramsArr.filter((k) => k !== newVal) : [...paramsArr, newVal];
				const finalVal = paramsArr.join(',');

				if (paramsArr.length === 0) {
					params.delete(type);
				} else {
					params.set(type, finalVal);
				}
			} else if (newVal) {
				params.set(type, newVal);
			} else {
				params.delete(type);
			}
		}
	} else {
		//! Single value mode
		const newVal = typeId?.toString();
		if (!newVal) {
			params.delete(type);
		} else {
			params.set(type, newVal);
		}
	}

	//! reset page if needed
	if (type !== 'page' && params.has('page')) {
		params.delete('page');
	}

	return params.toString();
}
